<app-dialog-container
    (closeEvent)="closeDialog()"
    [loading]="!data.filter"
>
    <app-filter-input
        [property]="data.filter"
        [disabledOptions]="data.disabledOptions"
    ></app-filter-input>
    <div class="level is-full-width">
        <div class="level-left"></div>
        <div class="level-right">
            <app-button
                [buttonText]="data.buttonText || 'Save'"
                (buttonClick)="validateAndClose()"
                [disabled]="!data.filter.isValid"
                [type]="'flat'"
            />
        </div>
    </div>
</app-dialog-container>
